/**
 * Slide-out panel for the first-time SubContractorHub Connect flow.
 *
 * Renders only the ConnectionTab — the paste-and-test form. Story SCH-2.1
 * renamed this from `SubContractorHubPanel` to make room for the new
 * 5-tab Configure panel that the architecture intended `SubContractorHubPanel`
 * to be (per architecture line 578 + SCH-1.1's T11.2 deferral note).
 *
 * The IntegrationsTab routes:
 * - "Connect SubContractorHub" CTA (no-row state) → ConnectSubContractorHubPanel
 * - "Configure" button on SyncStatusCard (existing-row state) → SubContractorHubPanel (5-tab)
 */

import { SlidePanel } from '@/components/ui/slide-panel';
import { ConnectionTab } from './ConnectionTab';

interface ConnectSubContractorHubPanelProps {
  isOpen: boolean;
  onClose: () => void;
}

export function ConnectSubContractorHubPanel({
  isOpen,
  onClose,
}: ConnectSubContractorHubPanelProps) {
  return (
    <SlidePanel
      isOpen={isOpen}
      onClose={onClose}
      title="Connect SubContractorHub"
      width="xl"
      topOffset="4.5rem"
    >
      <ConnectionTab onClose={onClose} />
    </SlidePanel>
  );
}
